const LowerThird = require("../shared/graphics/LowerThird");
const Message = require("../shared/graphics/Message");
const LowerThirdAnimated = require("../shared/graphics/LowerThirdAnimated");
const Score = require("../shared/graphics/Score");
const AnimatedBackground = require("../shared/graphics/AnimatedBackground");
const Time = require("../shared/graphics/Time");
const Celebration = require("../shared/graphics/Celebration");
const Checklist = require("../shared/graphics/Checklist");
const Credits = require("../shared/graphics/Credits");
const IconWithMessage = require("../shared/graphics/IconWithMessage");
const Image = require("../shared/graphics/Image");
const ImageSequence = require("../shared/graphics/ImageSequence");
const ImageWithMessage = require("../shared/graphics/ImageWithMessage");
const NowNextThen = require("../shared/graphics/NowNextThen");
const QRCode = require("../shared/graphics/QRCode");
const Section = require("../shared/graphics/Section");
const Slideshow = require("../shared/graphics/Slideshow");
const Social = require("../shared/graphics/Social");
const Ticker = require("../shared/graphics/Ticker");
const Video = require("../shared/graphics/Video");
const Audio = require("../shared/graphics/Audio");
const Webpage = require("../shared/graphics/Webpage");
const Map = require("../shared/graphics/Map");
const Lyrics = require("../shared/graphics/Lyrics");
const UtilityPattern = require("../shared/graphics/UtilityPattern");
const UtilityTimeOfDay = require("../shared/graphics/UtilityTimeOfDay");
const UtilityLargeText = require("../shared/graphics/UtilityLargeText");
const UtilitySpeakerTimer = require("../shared/graphics/UtilitySpeakerTimer");
const Rive = require("../shared/graphics/Rive");
const SolidColour = require("../shared/graphics/SolidColour");
const TimeOfDay = require("../shared/graphics/TimeOfDay");
const TimeCountdown = require("../shared/graphics/TimeCountdown");
const TimeToTimeOfDay = require("../shared/graphics/TimeToTimeOfDay");
const TimeCountup = require("../shared/graphics/TimeCountup");
const BigTimeCountdown = require("../shared/graphics/BigTimeCountdown");
const BigTimeCountup = require("../shared/graphics/BigTimeCountUp");
const BigTimeToTod = require("../shared/graphics/BigTimeToTod");
const InteractionJoin = require("../shared/graphics/InteractionJoin");
const InteractionCurrentQuestion = require("../shared/graphics/InteractionCurrentQuestion");
const CustomHTML = require('../shared/graphics/CustomHTML')
const Progress = require('../shared/graphics/Progress')

const definitions = {
	// group: {
	// 	name: "Group",
	// 	components: AnimatedBackground,
	// },
	animated_background: {
		name: "Animated background",
		pro: true,
		components: AnimatedBackground,
		hidden: false,
	},
	audio: {
		name: "Audio",
		pro: true,
		components: Audio,
		hidden: false,
	},
	big_time: {
		name: "Big Timer (Legacy)",
		pro: true,
		components: Time,
		hidden: true,
	},
	big_time_countdown: {
		name: "Big Timer Countdown",
		pro: true,
		components: BigTimeCountdown,
		hidden: false,
	},
	big_time_countup: {
		name: "Big Timer Count Up",
		pro: true,
		components: BigTimeCountup,
		hidden: false,
	},
	big_time_to_tod: {
		name: "Big Timer To Time of Day",
		pro: true,
		components: BigTimeToTod,
		hidden: false,
	},
	celebration: {
		name: "Celebration",
		theme: false,
		position: false,
		pro: true,
		components: Celebration,
		hidden: false,
	},
	checklist: {
		name: "Checklist",
		components: Checklist,
		hidden: false,
	},
	credits: {
		name: "Credits",
		updateJson: `{"lead":"Text","body":"Text"}`,
		pro: true,
		components: Credits,
		hidden: false,
	},
	// emoji_reaction: {
	// 	name: "Emoji reaction",
	// 	pro: true,
	// },
	icon_with_message: {
		name: "Icon with message",
		updateJson: `{"body":"Text"}`,
		pro: true,
		components: IconWithMessage,
		hidden: false,
		internalData: [{ Message: "body" }],
	},
	image: {
		name: "Image",
		components: Image,
		hidden: false,
	},
	image_sequence: {
		name: "Image sequence",
		components: ImageSequence,
		hidden: false,
		pro: true,
	},
	image_with_message: {
		name: "Image with message",
		updateJson: `{"body":"Text"}`,
		pro: true,
		components: ImageWithMessage,
		hidden: false,
		internalData: [{ Message: "body" }],
	},
	custom_html:{
		name: 'Custom HTML',
		components: CustomHTML,
		crop: false,
		theme: false,
	},
	lower_third: {
		name: "Lower third",
		updateJson: `{"line_one":"Text", "line_two":"Text"}`,
		internalData: [{ "First Line": "line_one" }, { "Second Line": "line_two" }],
		components: LowerThird,
		hidden: false,
	},
	lower_third_animated: {
		name: "Lower third animated",
		updateJson: `{"line_one":"Text", "line_two":"Text"}`,
		internalData: [{ "First Line": "line_one" }, { "Second Line": "line_two" }],
		pro: true,
		components: LowerThirdAnimated,
		hidden: false,
		transitionOverrideDisabled: true,
	},
	lyrics: {
		name: "Lyrics",
		pro: true,
		components: Lyrics,
		hidden: false,
		internalData: [{ "Current lyric": "current_lyric_text" }],
	},
	map: {
		name: "Map",
		components: Map,
		hidden: false,
	},
	message: {
		name: "Message",
		updateJson: `{"body":"Text"}`,
		internalData: [{ Body: "body" }],
		components: Message,
		hidden: false,
	},
	now_next_then: {
		name: "Now next then",
		pro: true,
		components: NowNextThen,
		hidden: false,
	},
	pdf: {
		name: "PDF viewer",
		pro: true,
		hidden: true,
		components: Section,
	},
	progress :{
		name: 'Progress',
		components: Progress,
		pro: true,
	},
	qr: {
		name: "QR code",
		pro: true,
		components: QRCode,
		hidden: false,
	},
	section: {
		name: "Section",
		components: Section,
		hidden: false,
	},
	slideshow: {
		name: "Slideshow",
		components: Slideshow,
		hidden: false,
		pro: true,
	},
	score: {
		name: "Score",
		components: Score,
		hidden: false,
	},
	social: {
		name: "Social",
		components: Social,
		internalData: [
			{ "Current comment": "current_comment" },
			{ "Current author": "current_author" },
		],
		hidden: false,
	},
	solid_colour: {
		name: "Solid colour",
		updateJson: `{"colour":"#222222"}`,
		pro: true,
		components: SolidColour,
		hidden: false,
		position: false,
	},
	ticker: {
		name: "Ticker",
		components: Ticker,
		hidden: false,
	},
	time: {
		name: "Time (Legacy)",
		components: Time,
		hidden: true,
	},

	time_tod: {
		name: "Time of Day",
		components: TimeOfDay,
		triggers: false,
		defaults: {
			status: "ready",
			timerType: "time_of_day",
			type: "time_tod",
			trim: false,
			pre: "",
			format: "HH:mm:ss", // https://momentjs.com/docs/#/displaying/
			position: "tl",
		},
	},
	time_countdown: {
		name: "Countdown timer",
		components: TimeCountdown,
		triggers: false,
		defaults: {
			status: "ready",
			type: "time_countdown",
			trim: false,
			pre: "",
			format: "mm:ss", // https://momentjs.com/docs/#/displaying/
			position: "tl",
			endAt: "",
			duration: "60000",
			pausedTimeLeft: 0,
			state: "reset",
			onEnd: "negative",
		},
	},
	time_to_tod: {
		name: "To Time of Day",
		components: TimeToTimeOfDay,
		triggers: false,
		defaults: {
			status: "ready",
			type: "time_to_tod",
			trim: false,
			pre: "",
			format: "mm:ss", // https://momentjs.com/docs/#/displaying/
			position: "tl",
			endTime: "",
			pausedTimeLeft: 0,
			state: "reset",
			onEnd: "negative",
		},
	},
	time_countup: {
		name: "Count up timer",
		components: TimeCountup,
		triggers: false,
		defaults: {
			status: "ready",
			type: "time_countup",
			trim: false,
			pre: "",
			format: "mm:ss", // https://momentjs.com/docs/#/displaying/
			position: "tl",
			startedAt: "",
			pausedTimeElapsed: 0,
			state: "reset",
			startOffset: "00:00:00",
		},
	},
	video: {
		name: "Video",
		pro: true,
		components: Video,
		hidden: false,
		internalData: [
			{ "Time remaining": "time_remaining" },
			{ "Time elapsed": "time_elapsed" },
		],
	},
	webpage: {
		name: "Webpage",
		components: Webpage,
		hidden: false,
	},
	// custom: {
	// 	name: "Custom",
	// 	components: Custom,
	// 	hidden: true,
	// 	pro: true,
	// },
	// interaction_join : {
	// 	name: "Q&A: Join link and QR code",
	// 	components: InteractionJoin,
	// 	pro: true,
	// },
	// interaction_current_question : {
	// 	name: "Q&A: Current Question",
	// 	components: InteractionCurrentQuestion,
	// 	pro: true,
	// },
	utility_pattern: {
		name: "Test Pattern",
		components: UtilityPattern,
		pro: true,
		theme: false,
		triggers: false,
	},
	utility_time_of_day: {
		name: "Time of day",
		components: UtilityTimeOfDay,
		pro: true,
		theme: false,
		triggers: false,
	},
	utility_large_text: {
		name: "Large text",
		components: UtilityLargeText,
		pro: true,
		theme: false,
		triggers: false,
	},
	utility_speaker_timer: {
		name: "Speaker timer",
		components: UtilitySpeakerTimer,
		pro: true,
		theme: false,
		triggers: false,
	},
	// rive: {
	// 	name: "Rive",
	// 	components: Rive,
	// 	pro: true,
	// 	theme: false,
	// 	triggers: false,
	// 	hidden: true
	// },
	// utility_sync: {
	// 	name: "Sync",
	// 	components: UtilitySpeakerTimer,
	// 	pro: true,
	// 	theme: false,
	// 	triggers: false,
	// },
};

const animatedBackgroundDefinitions = {
	floating_bulbs: {
		name: "Floating blubs",
	},
	moving_gradient: {
		name: "Moving gradient",
	},
};

const celebrationDefinitions = {
	balloons: {
		name: "Balloons",
	},
	confetti: {
		name: "Confetti",
	},
	money: {
		name: "Money",
	},
	emoji: {
		name: "Emoji",
	},
};

const imageTypesDefinitions = [
	"image/png",
	"image/jpeg",
	"image/gif",
	"image/svg",
];

const videoTypesDefinitions = ["video/mp4", "video/webm"];
const audioTypesDefinitions = ["audio/mp3", "audio/mpeg", "audio/wav"];

const patternTypesDefinitions = {
	p1: { name: "Colour bars" },
	p2: { name: "Grid and screen dimension" },
	p3: { name: "EBU 75%" },
};

module.exports = {
	definitions,
	animatedBackgroundDefinitions,
	celebrationDefinitions,
	imageTypesDefinitions,
	videoTypesDefinitions,
	audioTypesDefinitions,
	patternTypesDefinitions,
};
